import { SafeArea } from "./safe-area";

export type { SafeAreaProps } from "./safe-area";

export default SafeArea;
